export enum NewUsed {
  NEW = "New",
  USED = "Used",
}

export enum ItemCondition {
  EXCELLENT = "Excellent",
  GOOD = "Good",
  FAIR = "Fair",
  POOR = "Poor",
  WRECKER = "Wrecker",
}

export enum SellSafeCategory {
  GREEN = "1 Green",
  ORANGE = "2 Orange",
  RED = "3 Red",
}

export enum ClearingSaleLotStatus {
  PENDING = "Pending",
  APPROVED = "Approved",
  ACTIVE = "Active",
  // The item was removed from the sale before the auction started
  WITHDRAWN = "Withdrawn",
  // The item went for auction, but didn't meet the reserve price and was therefore not sold
  PASSED_IN = "Passed In",
  SOLD = "Sold",
  PAID = "Paid",
  FOR_SALE = "For Sale",
  // The item received no bids at auction. This is also known as No Sale in the AgriNous terminology
  // N.B. The term "No Sale" in the AgriNous terminology may also be used to refer to Withdrawn, and Passed In items
  NO_BIDS = "No Bids",
  WANTED = "Wanted",
}

export const LotStatusAsOptions = Object.values(ClearingSaleLotStatus).map(
  ls => ({
    label: ls,
    value: ls,
  }),
);

export enum ClearingSaleBuyerStatus {
  PAID = "Paid",
  PARTIALLY_PAID = "Partially Paid",
  SOLD = "Sold",
}

// Workflow order (least to most settled), for sorting buyers by status.
export const ClearingSaleBuyerStatusOrder: ClearingSaleBuyerStatus[] = [
  ClearingSaleBuyerStatus.SOLD,
  ClearingSaleBuyerStatus.PARTIALLY_PAID,
  ClearingSaleBuyerStatus.PAID,
];

export const TAX_RECEIPT = "Tax Receipt";
export const TAX_INVOICE = "Tax Invoice";
export const RCTI = "Recipient Created Tax Invoice";

export const getReportSentLabel = (report: string): string => `${report} Sent`;

export const CLEARING_SALE_VENDOR_REPORTS = [RCTI];
export const CLEARING_SALE_BUYER_REPORTS = [TAX_RECEIPT, TAX_INVOICE];

export const VENDOR_LABELS =
  CLEARING_SALE_VENDOR_REPORTS.map(getReportSentLabel);
export const BUYER_LABELS = CLEARING_SALE_BUYER_REPORTS.map(getReportSentLabel);
